import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-network-share",
  "use": "app-icon-network-share-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-network-share\"><path d=\"M24 12v12H0V12h24zm-8.5 1a1.5 1.5 0 00-1.499 1.565l-3.569 2.04a2 2 0 10-.029 2.82l2.598 1.558L13 21a1 1 0 10.515-.875l-2.597-1.557a2 2 0 00.012-1.094l3.453-1.973A1.5 1.5 0 1015.5 13zM11 0l3 4h10v7H0V0h11z\" fill=\"#6C92FA\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol